import React, { useState } from "react";
import { store } from "../../../global/app/store";
import { usePWDs } from "../Hooks/usePWDs";
import { UPDATE_9089_FORM } from "../../Forms/Form9089/queries";
import RedirectToForm from "../../SimpleForm/RedirectToForm";
import { FaSpinner } from "react-icons/fa";
import Button from "../../SimpleForm/UI/Button";
import getpdf from "../../Utils/PDFLink";
import { cleanData } from "../../Forms/Form9089/helpers";
import ModalSequence from "../../PrevailingWageLookup/Shared/LinkingPWSteps";
import "../../../global/css/component/legacyStyles.scss";

export default ({
  input,
  schemaProps: {
    pw_lookup: {
      formType: { this: linkFormType, to: currentFormType },
      worksiteFields,
      PWFields,
      buttonPrimary,
      socField,
      feinField,
      redirectToForm,
      showLinkedPWDLink,
      emergencyField,
    },
  },
  formValues,
  formApi,
  form_ui,
  history,
}) => {
  let is_emergency = formValues[emergencyField]?.toUpperCase() === "YES";

  let no_expiration = false;
  if (currentFormType === "9089") {
    no_expiration =
      formValues["occupationType"]?.toLowerCase() ===
      "college_university_teacher";
  }

  const { renderPWDs, PWs, addPW } = usePWDs({
    formType: currentFormType,
    formApi,
    is_emergency,
    worksiteFields,
    PWFields,
  });
  const primaryPW = PWs[0];

  const [primaryModalSequenceOpen, setModalSequenceOpen] = useState(false);
  const [additionalModalSequenceOpen, setAdditionalModalSequenceOpen] =
    useState(false);
  const [pdfLoading, setPDFLoading] = useState(false);

  const togglePrimaryModalSequence = () => {
    setModalSequenceOpen(!primaryModalSequenceOpen);
  };

  const handleGetPDF = async (value) => {
    setPDFLoading(true);
    await getpdf(value);
    setPDFLoading(false);
  };

  const toggleAdditionalModalSequenceOpen = () => {
    setAdditionalModalSequenceOpen(!additionalModalSequenceOpen);
  };

  const userData = store.getState().appReducer.userDataReducer.data;

  const user_id = userData.subject;
  const groupRole = userData.GroupRole;
  const group_id = userData.Group.id;

  const renderPWDButton = () => {
    // Primary PW query parameter and modal sequence props (defaulted)
    const queryParameters = {
      UISorting: {
        type: "Linkable",
        form_id: currentFormType,
        caseType: linkFormType,
        limit: 10,
        page: 0,
        sort_ascending: 0,
        sort_column: "dateSubmitted",
        is_emergency: is_emergency ? 1 : 0,
        no_expiration: no_expiration ? 1 : 0,
      },
      UISearch: {
        search: "",
      },
      getCasesInput: {
        user_id: user_id,
        groupRole: groupRole,
        group_id: group_id,
      },
    };
    let noPrefill = false;
    let open = primaryModalSequenceOpen;
    let toggleModalSequence = togglePrimaryModalSequence;
    let buttonText = buttonPrimary;

    // Additional PWs query parameter and modal sequence props (if primaryPW is linked)
    if (primaryPW) {
      if (socField) {
        queryParameters.UISorting.soc = formValues[socField];
      }
      if (feinField) {
        queryParameters.UISorting.fein = formValues[feinField];
      }
      queryParameters.UISorting.cases_to_exclude = PWs;

      noPrefill = true;
      open = additionalModalSequenceOpen;
      toggleModalSequence = toggleAdditionalModalSequenceOpen;
      buttonText = "Additional PWD(s)";
    }

    // For 9035 primary PW, query with fein
    if (currentFormType === "9035") {
      queryParameters.UISorting.fein = formValues[feinField];
    }

    // If more pws are linkable
    if (PWs?.length < PWFields?.PWLinkingFields?.length) {
      return (
        <div style={{ marginTop: "1rem" }}>
          <button
            type="button"
            onClick={toggleModalSequence}
            className="usa-button usa-button--outline"
          >
            {buttonText}
          </button>
          <ModalSequence
            noPrefill={noPrefill}
            open={open}
            toggleModalSequence={toggleModalSequence}
            formType={currentFormType}
            isEmergency={is_emergency}
            queryParameters={queryParameters}
            addPW={addPW}
            formApi={formApi}
          />
        </div>
      );
    }
  };

  return (
    <>
      <div>
        {primaryPW && renderPWDs()}
        {renderPWDButton()}
      </div>
      <br />
      {/**9089's code below */}
      <div>
        {!primaryPW && !!redirectToForm && (
          <RedirectToForm
            newFormType={redirectToForm}
            history={history}
            saveFormQuery={UPDATE_9089_FORM}
            saveRequest={{
              Form9089FormData: formValues,
              formUI9089: form_ui,
              id: window.location.pathname.split("/")?.[4],
            }}
            cleanData={cleanData}
            formDataAccessor="Form9089FormData"
          />
        )}
        {!!primaryPW && !!showLinkedPWDLink && (
          <>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Button onClick={() => handleGetPDF(primaryPW)}>
                {`Linked ${linkFormType}`}
              </Button>
              {!!pdfLoading && (
                <div style={{ paddingTop: "0.75em" }}>
                  <FaSpinner className="icon-spin" />
                </div>
              )}
            </div>
            <br />
            <div>
              Select the link above if you would like to review the prevailing
              wage determination you have associated with this application. If
              you wish to link a different prevailing wage determination, please
              use the PWD Case Lookup function above to update this link.
            </div>
          </>
        )}
      </div>
    </>
  );
};
